getLeadingOnes